import { Form, Formik } from "formik";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
} from "../../Theme";
import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import DRxInput from "../../uikit/DRxInput";
import DRxSelect from "../../uikit/DRxSelect";
import { MyProfilePersonalInfo } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";
import { useSelector } from "react-redux";

const initialStatePersonalInfo = {
  stateLicenseNo: "",
  firstName: "",
  lastName: "",
  ssn: "",
  middleInitial: "",
  prefix: "",
  suffix: "",
  email: "",
  specialization1: "0",
  specialization2: "0",
  dea: "",
  npi: "",
};

export default function PersonalInfo(props: any) {
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const doctorId = localStorage.getItem("doctorId");
  const ParamsData = {
    doctorId: doctorId,
  };
  const { data, loading }: any = useFetch(
    ParamsData,
    MyProfilePersonalInfo,
    []
  );

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Personal Info{" "}
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  Information about the prescriber's personal account on which
                  this account has been registered.
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Formik
            initialValues={data[0] ?? initialStatePersonalInfo}
            // validationSchema={yup.object().shape({
            //   lastName: yup
            //     .string()
            //     .matches(
            //       /^[aA-zZ\s]+$/,
            //       "Practice Name should be alphabetic characters."
            //     )
            //     .required("Practice Name is Required")
            //     .max(32)
            //     .min(1),

            //   prefix: yup.string().matches(/\D+$/, "Invalid Name Prefix"),
            //   suffix: yup.string().matches(/\D+$/, "Invalid Name Suffix"),
            //   StateLicenseNo: yup
            //     .string()
            //     .required("State License No is Required")
            //     .max(32)
            //     .min(1),
            //   specialization1: yup
            //     .string()
            //     .required("Area of Specialization1 is Required"),
            //   specialization2: yup
            //     .string()
            //     .required("Area of Specialization2 is Required"),
            // })}
            enableReinitialize
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                <Grid
                  container
                  item
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  justifyContent="space-between"
                  columnSpacing={2}
                >
                  {" "}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="lastname"
                      >
                        Last Name
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="lastname"
                            name="lastName"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.lastName}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.lastName &&
                              Boolean(registerProps.errors.lastName)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="middlename"
                      >
                        Middle Name
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="middlename"
                            name="middleInitial"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.middleInitial}
                            onChange={registerProps.handleChange}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="firstname"
                      >
                        First Name
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="firstname"
                            name="firstName"
                            type="text"
                            className="input"
                            disabled={false}
                            value={registerProps.values.firstName}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.firstName &&
                              Boolean(registerProps.errors.firstName)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Hidden mdDown>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="prefix"
                        >
                          Prefix
                        </Typography>
                        <Box className="nested">
                          <DRxInputStyle>
                            <DRxInput
                              id="prefix"
                              name="prefix"
                              type="text"
                              className=""
                              disabled={false}
                              onChange={registerProps.handleChange}
                              value={registerProps.values.prefix}
                            />
                          </DRxInputStyle>
                          <Box className="nested">
                            <Typography
                              component="label"
                              color={greyColor}
                              variant="body2"
                              htmlFor="suffix"
                              className="mr suffix"
                              marginRight={2}
                            >
                              Suffix
                            </Typography>
                            <Box className="nested">
                              <DRxInputStyle>
                                <DRxInput
                                  id="suffix"
                                  name="suffix"
                                  type="text"
                                  className=""
                                  disabled={false}
                                  value={registerProps.values.suffix}
                                  onChange={registerProps.handleChange}
                                />
                              </DRxInputStyle>
                              <Typography
                                component="div"
                                color={greyColor}
                                variant="body2"
                                className="info"
                              >
                                MD, PhD etc
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                  </Hidden>
                  <Hidden mdUp>
                    <Grid item xs={12}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="prefix"
                        >
                          Prefix
                        </Typography>
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="prefix"
                              name="prefix"
                              type="text"
                              className=""
                              disabled={false}
                              onChange={registerProps.handleChange}
                              value={registerProps.values.prefix}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="suffix"
                          className="mr suffix"
                        >
                          Suffix
                        </Typography>
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="suffix"
                              name="suffix"
                              type="text"
                              className=""
                              disabled={false}
                              value={registerProps.values.suffix}
                              onChange={registerProps.handleChange}
                            />
                          </DRxInputStyle>
                          <Typography
                            component="div"
                            color={greyColor}
                            variant="body2"
                            className="info"
                          >
                            MD, PhD etc
                          </Typography>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                  </Hidden>{" "}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="email"
                      >
                        E-mail
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="email"
                            name="email"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.email}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.email &&
                              Boolean(registerProps.errors.email)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="email"
                      >
                        State License No
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="stateLicenseNo"
                            name="stateLicenseNo"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.stateLicenseNo}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.stateLicenseNo &&
                              Boolean(registerProps.errors.stateLicenseNo)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="NPI"
                      >
                        NPI
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="NPI"
                            name="npi"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.npi}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.npi &&
                              Boolean(registerProps.errors.npi)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="deaNo"
                      >
                        Dea No
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="deaNo"
                            name="dea"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.dea}
                            onChange={registerProps.handleChange}
                            onBlur={registerProps.handleBlur}
                            error={
                              registerProps.touched.dea &&
                              Boolean(registerProps.errors.dea)
                            }
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="specialization1"
                      >
                        Area of Specialization1
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect
                            name="specialization1"
                            id="specialization1"
                            data={
                              AllDropdwonsState?.specializationOptions ?? [
                                { value: "", label: "" },
                              ]
                            }
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="specialization2"
                      >
                        Area of Specialization2
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect
                            name="specialization2"
                            id="specialization2"
                            data={
                              AllDropdwonsState?.specializationOptions ?? [
                                { value: "", label: "" },
                              ]
                            }
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
    </>
  );
}
